import React from "react";
import styles from "../ChartSelector.module.css";
import Charts from "../Charts.json";

export const getChartOptions = (setChartType) => {
	let list = [];
	for (const property in Charts) {
		list.push(
			<p
				key={property}
				className={styles.option}
				onClick={() => setChartType(Charts[property])}
			>
				{Charts[property]}
			</p>
		);
	}
	return list;
};
